/**
 * @generated SignedSource<<c3f90371f4034faee0c79f2b97a62b23>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountName"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pAccountId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "vendorAccountId"
},
v7 = [
  {
    "kind": "Variable",
    "name": "accountName",
    "variableName": "accountName"
  },
  {
    "kind": "Variable",
    "name": "endTs",
    "variableName": "endDate"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  },
  {
    "kind": "Variable",
    "name": "pAccountId",
    "variableName": "pAccountId"
  },
  {
    "kind": "Variable",
    "name": "startTs",
    "variableName": "startDate"
  },
  {
    "kind": "Variable",
    "name": "vendorAccountId",
    "variableName": "vendorAccountId"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "VendorTransactionsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "VendorResellerBindCardChargeWSum2SConnection",
        "kind": "LinkedField",
        "name": "getvendorresellerbindcardchargeswithsummary2",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VendorTransactionsList_tl"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "VendorTransactionsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "VendorResellerBindCardChargeWSum2SConnection",
        "kind": "LinkedField",
        "name": "getvendorresellerbindcardchargeswithsummary2",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "VendorResellerBindCardChargeWSum2",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bcChargeSum",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rebateSum",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerAccountId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerAccountName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerAppId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerAppStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "provisioningAccountId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appLogo",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "transactionId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "transactionTime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bindCardCharge",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rebate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "programName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "resellerPId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vendorPayoutChargeId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vendorPayoutId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6db2c9942d621c3dffa48c0d56e72bed",
    "id": null,
    "metadata": {},
    "name": "VendorTransactionsQuery",
    "operationKind": "query",
    "text": "query VendorTransactionsQuery(\n  $startDate: Datetime\n  $endDate: Datetime\n  $accountName: String\n  $pAccountId: UUID\n  $vendorAccountId: UUID\n  $first: Int\n  $offset: Int\n) {\n  getvendorresellerbindcardchargeswithsummary2(startTs: $startDate, endTs: $endDate, accountName: $accountName, pAccountId: $pAccountId, vendorAccountId: $vendorAccountId, first: $first, offset: $offset) {\n    totalCount\n    ...VendorTransactionsList_tl\n  }\n}\n\nfragment VendorTransactionsList_tl on VendorResellerBindCardChargeWSum2SConnection {\n  nodes {\n    bcChargeSum\n    rebateSum\n    customerAccountId\n    customerAccountName\n    customerAppId\n    customerAppStatus\n    provisioningAccountId\n    appId\n    appName\n    appLogo\n    transactionId\n    transactionTime\n    bindCardCharge\n    rebate\n    programName\n    resellerPId\n    vendorPayoutChargeId\n    vendorPayoutId\n  }\n}\n"
  }
};
})();

node.hash = "f495c465a2396f2efb4cdaa8063caa18";

module.exports = node;
